const locale = {
    //welcome_to_flap: "Welcome to FLAP App",
    Welcome: {
        header: "Welcome to FLAP App",
        p1: "The FLAP App is a BirdSafe® DIY risk assessment tool designed to estimate daytime and nighttime collision threats that a building and its façades pose to bird species.",
        p2: "A ‘façade’ is any exterior side of a building that can pose a specific threat to bird collisions.",
        p3: "To determine a building and its façades' collision threat ratings, follow the steps under ‘Building Account Settings'.",
        p4: "This app provides a general assessment of a building and its façades. FLAP Canada recommends a full assessment be conducted for accuracy. ",
        vist_birdsafe: "Visit birdsafe.ca for full assessment details",
        p5: "BirdSafe® risk assessment would not be possible without the generous input of North America's leading experts in bird building collisions.",
        acknowledgements: "Acknowledgements",
        begin: "Begin Risk Assessment",
    },
    Manage: {
        header: "Buildings Account Settings",
        step1: "STEP 1. Add building street name and number to be assessed",
        add: "Add",
        delete: "Delete",
        or: "OR",
        select_existing_building: "Select existing building",
        step2: "STEP 2. Add all façades to be assessed for",
        visit_birdsafe: "Visit birdsafe.ca for examples of façades",
        select_existing_facade: "Select existing façade.",
        step3: "STEP 3. Assess selected façade for",
        assess: "Assess",
        optional_track_collision_rates: "OPTIONAL: Track collision rates at individual façades being assessed for",
        global_mapper: "Global Bird Collision Mapper",
        
        enter_building_name: "Please enter building name:",
        confirm_delete_building: "Are you sure you want to delete this building?",
        building: "Building",
        current_building: "current building",
        enter_facade_name: "Please enter Façade name:",
        confirm_delete_facade: "Are you sure you want to delete this Façade?",
        facade: "Façade",
        current_facade: "current building",
    },
    Assess: {
        header: "Assess Selected Façade",
        currently_assessing: "You are currently assessing", // fragment
        facade_for: "façade for", // fragment
        to_include_image_of: "To include an image of", // fragment
        take_picture_or_select_image_now: "in this report, take a picture now or select an existing image from your device.", // fragment
        take_a_picture: "Take a Picture",
        select_an_image: "Select an Image",
        daytime_factors: "Daytime Factors: ",
        observe_factors_in_daylight: "Observe the following factors during daylight",
        daytime_prompt: "To determine a façade’s collision threat rating, answer all of the following questions by selecting ‘YES’ or ‘NO’.",
        yes: "YES",
        no: "NO",
        regional_landscape: "Regional Landscape:",
        google_maps: "Google Maps",
        are_features_regional: "Do one or more of the following regional landscape features exist within 5 km (3 miles) of building?",
        q01: "Dense woodlots, scrublands and/or meadows.",
        q02: "Flowing/open water and/or wetlands (e.g. river, marsh, lake, etc.).",
        q03: "Mountains, hills, ravines and/or distinct shoreline.",
        local_landscape: "Local Landscape:",
        are_features_local: "Do one or more of the following local landscape features exist within 100 m (300 ft) of building?",
        q04: "Patchy to dense trees and/or shrubs.",
        q05: "Treed pathways guiding birds toward façade.",
        q06: "Flowered gardens, tall grasses, green roofs and/or terraces.",
        q07: "Water features providing opportunity for bathing and drinking.",
        facade_type: "Façade Type:",
        select_facade_type: "Select Façade Type",
        q08: "", // removed?
        design_feature_options: [
            "Glass windbreaks, shelters, sound barriers, railings",
            "Linkways, lobbies, alcoves, solariums, corners",
            "Open top atria and enclosed courtyards",
            "Glass walls adjacent to lobbies, vegetated roof and terraces",
            "Home windows",
        ],
        q09: [
            "Is design feature less than 10 m from building?",
            "Does daylight fill interior space?",
            "Is design feature less than 3 storeys?",
            "Does glass uniformly cover 50% or more of the façade?",
            "Is there a bird feeder(s) located than more 1 m (3 ft) from window being assessed?",
        ],
        q10: [
            "Is design feature greater than 5 sqm in size?",
            "Is design feature greater than 5 sqm in size?",
            "Is there vegetation/water features found within enclosure?",
            "Is there continuous glass expanses located within the first 5 storeys?",
            "Is there vegetation facing window being assessed?",
        ],
        properties_of_glass: "Properties of Glass:",
        q11: "Can you see a faint to distinct reflection of vegetation and/or sky under varying daylight conditions?",
        q12: "Is vegetation visible inside or on far side of building façade?",
        visual_markers: "Visual Markers:",
        def_of_visual_marker: "* A 'visual marker' is pattern of any shape that is applied onto or is in front of a window's surface that meets the below criteria.",
        see_examples_of_visual_markers: "See Examples of Visual Markers",
        note_that_inverted: "NOTE: Answer ‘YES’ for all 4 of the following questions if insect screens are permanently fastened to the outside surface of the façade being assessed.",
        q13: "Are there visual markers spaced no more than 5 cm (2 inches) horizontally and/or 5 cm (2 inches) vertically apart?",
        q14: "Are there visual markers clearly visible under varying daylight conditions?",
        q15: "Are there visual markers that cover the majority of glass surface up to 16 m (50 ft) above ground level?",
        q16: "Are there visual markers located on the outside surface of glass?",
        nighttime_factors: "Nighttime Factors: ",
        observe_factors_in_darkness: "Observe the following factors during darkness",
        nighttime_prompt: "To determine a building’s nighttime collision threat rating, answer all of the following questions by selecting ‘YES’ or ‘NO’.",
        local_landscape_with_dist: "Local Landscape (<1.5 km of building):",
        q17: "Do neighboring buildings reduce sky and/or horizon visibility?",
        q18: "Is there shoreline within 1.5 km (1 mile) of area being evaluated?",
        building_lighting: "Building Lighting:",
        q23: "Is building greater than 3 storeys?",
        q19: "Is light inside building visible from exterior?",
        q20: "Are indoor plants (artificial or real) visible from exterior?",
        q21: "Is exterior light being cast on building?",
        q22: "Is exterior light being directed upward into the night sky?",
        save_responses_for: "STEP 4: Save all responses for", // fragement
        // facade_for is already defined
        save_responses: "Save Responses",
        select_next_facade_for: "STEP 5: Select the next façade for", // fragment
        select_next_facade: "Select Next Façade",
        step6: "STEP 6: Generate report for", // fragment
        view_reports: "View Reports",

        current: "currrent",
        current_building: "current building",
        current_facade: "current façade",
        design_feature: "Design Feature",

        webcam: {
            capture_photo: "Capture photo",
        },
    },
    Report: {
        header: "Generate Reports",
        generate_report: "Generate Report",
        //include_images: "Include images in report",
        //preview_of_report_for: "Preview of report for", // fragment
        facade_threat_rating_scale: "Façade Threat Rating Scale",
        note: "* A 'high-risk' to 'lethal' rating requires immediate action. See the below links for resources on how best to mitigate this threat.",
        low_risk: "Low Risk",
        no_action_required: "No action is required",
        moderate_risk: "Moderate Risk",
        action_is_discretionary: "Action is discretionary",
        high_risk: "High Risk",
        strongly_recommend_action: "Strongly recommend action be taken",
        lethal: "Lethal",
        mandatory_action: "Mandatory that action be taken under regulatory laws",
        canadian_law: "Canadian law under SARA and the EPA",
        //share_report: "Share Report",
        preview_report_for_different_building: "Preview Report for Different Building:",

        building: "Building",

        generate: {
            report_header: "FLAP App Report",
            report_generated_for: "The following ratings are the results of FLAP Canada's BirdSafe Building Risk Assessment for: ",
            facade_colon: "Façade: ",
            algorithm: {
                daytime_incomplete: "Façade Assessment Incomplete for Daytime Rating",
                daytime_rating_is: "Daytime Rating:    ",
                nighttime_incomplete: "Façade Assessment Incomplete for Nighttime Rating",
                nighttime_rating_is: "Nighttime Rating:    ",
            },
        },
    },
    Links: {
        header: "Helpful Links",
        homes_safe_for_birds: "Homes Safe for Birds",
        workplaces_safe_for_birds: "Workplaces Safe for Birds",
        global_mapper: "Global Bird Collision Mapper",
        collision_count_week: "Collision Count Week",
        birdsafe_consulting_serice: "BirdSafe® Consulting Service",
        contact_flap_canada: "Contact FLAP Canada",
    },
    About: {
        header: "About FLAP Canada",
        about_info: "FLAP Canada is a registered charity who for over 25 years has been protecting bird species from collisions with built structures. Your donation will help us continue to develop collision prevention tools like the FLAP App.",
        visit_site: "VISIT flap.org",
        give: "GIVE",
        // share_this_app: "Share This App", // they can just send a link
        report_a_bug: "Report a Bug",
        // french is not powered by Yandex!
    },
    copyright: "This app and its methodology is the sole property of FLAP Canada and cannot be used for profit or reproduced, in whole or in part, without explicit permission of the owner. *BirdSafe is a registered trademark of the Fatal Light Awareness Program (FLAP) Canada.",
    developers: "App developers: Andrew Fryer and Michael Mesure",

    errors: {
        // I shouldn't need many, actually...
    }
}

export default locale;


// WEBPACK FOOTER //
// ./src/localization/English.js